import { Container, Row } from 'react-bootstrap';
import styled from 'styled-components';
import { calcResize } from 'components/Layout/styles';
import { mediaBreakpointDown, mediaBreakpointUp } from 'utils/styledCssHelpers';
import SectionTitle from 'components/SectionTitle';
import SplitSectionWithImage from 'containers/SplitSectionWithImage';

/*
calc( 48px + (68 - 48) * (100vw - 320px) / (1024 - 400) );

48 - Min size
68 - Max size

320 - min screen size
1024 - max screen size

*/

export const SCardContainer = styled.div``;

export const SRow = styled(Row)`
  margin-top: ${calcResize(20, 50)};

  & > div {
    display: flex;
    flex-direction: column;

    & > div {
      flex: 1;
    }
  }
`;

export const SDashboardSection = styled.section`
  overflow-x: hidden;
`;

export const SHeroTitle = styled.div``;

// End Hero Section Sub Components

export const SSellingInYourArea = styled(Container).attrs(() => ({
  className: 'mt-4 container-fluid',
}))`
  background-color: #192f54;
  height: auto;
  width: 100%;
`;

// End of Selling in your area

export const SParagraphHolder = styled.div`
  padding-top: 20px;
  justify-content: center;

  ${mediaBreakpointDown(
    'md',
    `
    display: flex;
    flex-flow: column;
    align-items: center;
  `,
  )};
`;

export const SSectionTitle = styled(SectionTitle)``;

export const STitle = styled.span`
  color: ${props => (props.$inverted ? '#ffffff' : props.theme.colors.main)};

  font-size: inherit;
  & span {
    font-size: inherit;
  }
`;

export const SPaddedSection = styled.section`
  @media only screen and (max-width: 767.98px) {
    padding-top: ${props => props.$mobilePadding || 'unset'};
    padding-bottom: ${props => props.$mobilePadding || 'unset'};
  }
  ${mediaBreakpointUp(
    'xl',
    `
padding: 0 65px !important;
`,
  )}
  ${mediaBreakpointUp(
    'lg',
    `
padding: 0 65px;
`,
  )};
`;

export const SSplitSectionWithImage = styled(SplitSectionWithImage)`
  position: relative;
  padding-top: 100px !important;
  margin: 0;
  padding-bottom: ${props =>
    props.$showOverlayImage ? '140px  !important' : '100px  !important'};
  ${mediaBreakpointDown(
    'md',
    `
    padding-top: 85px  !important;
    padding-bottom: 50px  !important;

  `,
  )}
`;

// End of Compliance Monitoring
